var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { AspectKeyRegional } from '../localKey/AspectKeyRegional';
import { AspectKeyProxies } from '../traitKey/proxies/AspectKeyProxies';
import { AspectActive } from './4_active/AspectActive';
export class AspectRegional {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get valueOf() {
        return this.aspect.regional.localEval.valueOf;
    }
    get activesOf() {
        return this.aspect.regional.localEval.activesOf;
    }
    get activeOf() {
        return this.aspect.regional.localEval.activeOf;
    }
    get mixedValueOf() {
        return this.aspect.regional.localEval.mixedValueOf;
    }
    get attachedTraits() {
        return this.aspect.traits.map((trait) => trait.toAttached);
    }
    get aspectActive() {
        return new AspectActive(this);
    }
    get aspectKey() {
        return createTransformer((traitKey) => new AspectKeyRegional(this, traitKey));
    }
    get localEval() {
        return new AspectKeyProxies(this);
    }
}
__decorate([
    memoize
], AspectRegional.prototype, "aspectActive", null);
__decorate([
    memoize
], AspectRegional.prototype, "aspectKey", null);
__decorate([
    memoize
], AspectRegional.prototype, "localEval", null);
